import AuthHelper from 'helpers/auth_helper';

const useDiscoverWaitlistTip = () => {
  if (AuthHelper.hasTalentProfile)
    return 'To get off the waitlist within a day, add more pictures to your portfolio.';
  return 'To get off the waitlist within 30 minutes, post your job or contact one of our client managers for assistance.';
};

export default useDiscoverWaitlistTip;
